import { ROTA_APIS } from "@/api_framework/api_config";
import { IRotaManagementRotaCategoryResponse } from "@/api_framework/api_modals/Rota";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setCategory } from "@/app_redux/reducers/slices/auth/rota_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useRotaShiftCategoryAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const execute = useCallback(
    async (extraParam?: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const params: Record<string, string> = {};
        if (extraParam) {
          params["action"] = extraParam;
        }
        await axios
          .get(ROTA_APIS?.ROTA_SHIFT_CATEGORY?.baseURL ?? "", {
            params,
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IRotaManagementRotaCategoryResponse>) => {
            if (res.data.status === true) {
              dispatch(setCategory({ data: res.data.data }));
            } else {
              //
              dispatch(
                setCategory({
                  data: [],
                }),
              );
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_BAD_REQUEST") {
              toast.error("Error while fetching org services");
            }
            if (e.status === 400) {
              toast("Services records not found");
            }
            if (e.response.status === 500) {
              toast.error("Server error 500");
            }
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
